export const endpoint = '/clients';
export const tableName = 'dashboardClients';



// WEBPACK FOOTER //
// ./src/containers/DashboardClients/constants.js